
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import {  message, Divider } from "antd";

import CreateTransferReport from './EachTransfer/eachTransfer';
import { on_migration_progress, clear_migration, refresh_migrations_history, aws_migrations_history,aws_migrations_retry} from "../../../actions/migrations";
import {refresh_rm, refresh_profile}   from "../../../actions/auth";

import "./transferHistory.scss";

class TransferHistory extends Component{
    constructor(props) {
        super(props)
        
        this.state = {
            awshistory: [],
            user:{},
            migration:{},
            migrations:{},
            disabledRetry:[],
            downloadUrl:null,
            history : [],
        }
    }
    
    componentDidMount() {
        this.props.aws_migrations_history(this.props.user.id)
        this.props.refresh_migrations_history()
        this.props.refresh_rm()
        // this.stats_loop()
    }

    componentWillReceiveProps(props) {
        this.setState({migrations:props.ongoing, history:props.history, awshistory:props.awshistory, user:props.user, awsLoading:props.awsLoading})
        // console.log("migrations", props.awshistory);
    }

    render(){
        // console.log("hi in recent trabsfer", this.state);
        const { user } = this.props;
        let counter = 0;

        let {speeds, speed_stat={}, transferred_stat={}, remaining_stat={},
        history:{today:today_history=[], yesterday:yesterday_history=[], week:week_history=[]}={},
        awshistory:{today:aws_today_history=[], YesterdayList:aws_yesterday_history=[], ThisWeek:aws_week_history=[]}={}, migrations={}, downloadUrl, awsLoading} = this.state

        const recentTransferTableHeader = <ul>
                                            <li>source</li>
                                            <li>destination</li>
                                            <li>cloud type</li>
                                            <li>size</li>
                                            <li>date</li>
                                        </ul>

        // console.log("aws history", aws_week_history);
        const ReportList = aws_week_history.slice(0, 5).map((t,index)=>{
            return(
                <div>
                    <Divider/>
                    <CreateTransferReport 
                        key = {index}
                        source = {t.SourceCloud}
                        destination = {t.DestinationCloud}
                        cloudtype = {t.SourceBucket}
                        size = {t.TotalSize}
                        date = {t.BatchTransferDateTime}
                    />
                </div>
            )
            counter++;
        })
        return(
            <div className="recent-transfer-wrapper">
                <div className="header">
                    <h3>Transfer Costs</h3>
                    {/* <h4><a href="">More...</a></h4> */}
                </div>
                <div className="table-header">
                    {recentTransferTableHeader}
                </div>
                <div>
                    {ReportList}
                </div>
            </div>
        )
    }
}
export default withRouter(connect(({migrations={},auth}) => ({user : auth.user,ongoing:migrations.ongoing, history:migrations.history, awshistory:migrations.awshistory, awsLoading:migrations.awsLoading}), dispatch => bindActionCreators({on_migration_progress, clear_migration, refresh_migrations_history, aws_migrations_history, refresh_rm, refresh_profile, aws_migrations_retry}, dispatch))(TransferHistory))
